<template lang="pug">
.container-tags-devices
  h5(v-if="this.$store.state.Device.device_tags.length === 0") {{ $t('No tags in Network. Please edit and tag some devices to use tag filter.') }}
  .switch(v-if="this.$store.state.Device.device_tags.length > 0")
    el-checkbox.allAny(id="TagFilterDevices-allRequiredCheckbox", v-if="deviceFilterTagsLength > 1", v-model="allChecked") {{$t("all tags required")}}&nbsp;&nbsp;
    el-button(id="TagFilterDevices-switchViewButton", type='text', size='mini', @click='switchTagViewMode()', :title='$t("Switch filter view")')
      font-awesome-icon(:icon="!deviceTagDropdownViewActive ? 'caret-square-down' : 'cloud'")
    el-button(id="TagFilterDevices-clearTagsButton", type='text', size='mini', @click='clearTagFilter()', :disabled='deviceFilterTagsLength === 0', :title='$t("Reset filter")')
      font-awesome-icon(icon="times")
  .deviceTags(v-if='!deviceTagDropdownViewActive')
    el-badge.badge-item(v-if='deviceTag.device', :value="deviceTag.device.length", v-for='deviceTag in this.$store.state.Device.device_tags', :key='deviceTag.id')
      el-button(:id="'TagFilterDevices-tag'+deviceTag.id",size="mini", :type="getTypeForTag(deviceTag)", @click.native="toggleTagInFilter(deviceTag)", @dblclick.native='editNetworkTag(deviceTag)', plain) {{ deviceTag.name }}
  .deviceTags(v-if='deviceTagDropdownViewActive')
    el-select.device-tag-dropdown(
      id="TagFilterDevice-tagSelect",
      v-model='selectedDeviceTags',
      multiple,
      filterable,
      :placeholder='$t("Select tags to filter devices")')
      el-option(v-for='tag in this.$store.state.Device.device_tags' :id="'TagFilterDevices-tagOption'+tag.id" :key='tag.id' :label='tag.name' :value='tag.id')
  el-dialog(:close-on-click-modal="false", :visible.sync='editTagFormVisible', append-to-body, @close='editTagFormVisible = false; editedTag = undefined')
    .container(v-if='editedTag')
      DeviceTagEditorGlobal(:editedTag='editedTag', @reloadDevice='emitReloadDevice()')
</template>

<script>

import Vue from 'vue'
import NaviButtons from './NaviButtons'
import DeviceTagEditorGlobal from './DeviceTagEditorGlobal'

export default {
  props: ['side'],
  components: {
    NaviButtons,
    DeviceTagEditorGlobal
  },
  created () {
    this.deviceTagDropdownViewActive = this.$store.state.User.user.deviceTagDropdownViewActive
    this.selectedDeviceTags = this.$store.state.Device.device_filter[this.side].deviceTags.map(t => t.id)
  },
  watch: {
    allChecked: async function (newVal, oldVal) {
      this.$store.dispatch('Device/setTagAllAnyInFilter', [ this.side, newVal ])
    },
    selectedDeviceTags: async function (newVal, oldVal) {
      this.$store.dispatch('Device/setTagsInFilter',
        [ this.side, this.$store.state.Device.device_tags.filter(dt => newVal.includes(dt.id)) ]
      )
    },
    deviceFilterTagsLength: async function (newVal, oldVal) {
      if (newVal < 2) {
        this.allChecked = false
        this.$store.dispatch('Device/setTagAllAnyInFilter', [ this.side, false ])
      }
    }
  },
  data () {
    return {
      errors: {
      },
      allChecked: false,
      negative: false,
      editTagFormVisible: false,
      editedTag: undefined,
      deviceTagDropdownViewActive: false,
      selectedDeviceTags: []
    }
  },
  methods: {
    clearTagFilter () {
      this.$store.dispatch('Device/clearFilter', this.side)
      this.selectedDeviceTags = []
    },
    async switchTagViewMode () {
      this.deviceTagDropdownViewActive = !this.deviceTagDropdownViewActive
      if (this.deviceTagDropdownViewActive) {
        this.selectedDeviceTags = this.$store.state.Device.device_filter[this.side].deviceTags.map(dt => dt.id)
      }
      await this.setViewPreference()
    },
    async setViewPreference () {
      await Vue.axios.post('user/setViewPreference', {
        deviceTagDropdownViewActive: this.deviceTagDropdownViewActive
      })
      await this.$store.dispatch('User/getMe')
    },
    editNetworkTag (tag) {
      console.log(this.$store.state.User.user.userPrivileges.map(i => i.entity === 'medium'))
      this.editedTag = JSON.parse(JSON.stringify(tag))
      this.editTagFormVisible = true
    },
    toggleTagInFilter (tag) {
      this.$store.dispatch('Device/toggleTagInFilter', [ this.side, tag ])
    },
    getTypeForTag (tag) {
      if (!tag.id) return
      let tagIndex = this.$store.state.Device.device_filter[this.side].deviceTags.findIndex(filterTag => filterTag.id === tag.id)
      if (tagIndex > -1) {
        return 'warning'
      } else {
        return 'info'
      }
    }
  },
  computed: {
    deviceFilterTagsLength () {
      if (!this.$store.state.Device.device_filter[this.side].deviceTags) return 0
      return this.$store.state.Device.device_filter[this.side].deviceTags.length
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../../theme-m4b/src/common/var.scss";
.container-tags-devices {
  margin-bottom: 5px;
  .switch {
    text-align:right;
  }
}
.device-tag-dropdown {
  width: 95%;
}
</style>



// WEBPACK FOOTER //
// src/components/Device/TagFilterDevices2.vue